import { FormEditIcon } from 'assets/icons';
import FormCloseReactIcon from 'assets/react-icons/FormCloseReactIcon';
import LineItemPlusReactIcon from 'assets/react-icons/LineItemPlusReactIcon';
import { IInvoiceServiceCharge } from 'containers/invoices/invoices.model';
import { FC } from 'react';
import { twMerge } from 'tailwind-merge';
import { VoidFn } from 'types/baseTypes';
import { getAmountWithCurrency } from 'utils/amountUtils';

interface AddServiceChargeSectionProps {
  className?: string;
  selectedServiceCharge?: IInvoiceServiceCharge;
  isAddServiceChargeDisabled?: boolean;
  onAddServiceCharge: VoidFn;
  onRemoveServiceCharge: VoidFn;
  onEditServiceCharge: VoidFn;
  isFromBillingTab?: boolean;
}

const AddServiceChargeSection: FC<AddServiceChargeSectionProps> = ({
  onAddServiceCharge,
  onRemoveServiceCharge,
  onEditServiceCharge,
  selectedServiceCharge,
  isAddServiceChargeDisabled = false,
  className = '',
  isFromBillingTab = false
}) => {
  const hasSelectedServiceCharge: boolean = +selectedServiceCharge.amount > 0 || +selectedServiceCharge.percentage > 0;

  const getServiceChargeTotalAmountInCurrency = (serviceCharge: IInvoiceServiceCharge): string => {
    return getAmountWithCurrency(serviceCharge.totalAmount);
  };

  const onAddServiceChargeClick = (): void => {
    if (isAddServiceChargeDisabled) {
      return;
    }
    onAddServiceCharge();
  };

  const onEditServiceChargeClick = (): void => {
    if (isAddServiceChargeDisabled) {
      return;
    }
    onEditServiceCharge();
  };

  return (
    <div
      id="invoice-add-service-charge"
      className={twMerge(
        `
         border-b border-borderGray p-5
        `,
        className
      )}>
      {hasSelectedServiceCharge ? (
        <div className={`relative flex ${isFromBillingTab ? '' : 'min-h-[75px]'} w-full flex-row`}>
          <div className="my-auto flex w-full flex-row">
            <div
              onClick={onEditServiceChargeClick}
              className={`h-fit w-1/2  break-words text-17px font-semibold ${
                isAddServiceChargeDisabled ? 'text-primaryText' : 'cursor-pointer text-secondary'
              }`}>
              {selectedServiceCharge.name}
            </div>
            <div className="h-fit w-1/2 break-words text-right text-17px font-normal text-heading">
              {getServiceChargeTotalAmountInCurrency(selectedServiceCharge)}
            </div>
          </div>
          {!isFromBillingTab && (
            <>
              <FormCloseReactIcon
                id="invoice-service-charge-remove-icon"
                onClick={onRemoveServiceCharge}
                className="absolute top-3 right-[-45px] shrink-0 cursor-pointer"
              />
              <FormEditIcon
                id="invoice-service-charge-edit-icon"
                onClick={onEditServiceChargeClick}
                className="absolute bottom-3 right-[-45px] shrink-0 cursor-pointer"
              />
            </>
          )}
        </div>
      ) : (
        <div
          className={`${
            isAddServiceChargeDisabled ? 'cursor-not-allowed opacity-80' : 'cursor-pointer'
          } flex  items-center gap-2 ${isFromBillingTab ? 'text-sbase' : 'text-17px'} font-semibold text-secondary`}
          onClick={onAddServiceChargeClick}
          id="create-invoice-add-additional-tax-fees-icon">
          <LineItemPlusReactIcon id="create-invoice-add-additional-tax-fees-icon" className="shrink-0" />
          Add service charge
        </div>
      )}
    </div>
  );
};

export default AddServiceChargeSection;
